<template>
    <div class="bgs">
        <div class="bgs__bg bg bg--01"></div>
        <div class="bgs__bg bg bg--02"></div>
        <div class="bgs__bg bg bg--03"></div>
        <div class="bgs__bg bg bg--01"></div>
    </div>
</template>

<script>
import { gsap } from 'gsap';

export default {
    props: {
        backgroundIndex: Number,
    },
    watch: {
        backgroundIndex() {
            this.setBackground();
        },
    },
    methods: {
        setBackground() {
            gsap.to(`.bgs__bg:nth-child(-n+${this.backgroundIndex})`, {
                duration: 0.8,
                autoAlpha: 1,
                scale: 1,
            });

            gsap.to(`.bgs__bg:nth-child(n+${this.backgroundIndex + 1})`, {
                duration: 0.8,
                autoAlpha: 0,
                scale: 1.2,
            });
        },
    },
};
</script>
